<template>
    <form>
        <label for="category">
            Category:
            <select id="category" v-model="category" @change="redirectToCategory">
                <option value="">All categories</option>
                <option
                    :value="category.url"
                    :key="category.id"
                    v-for="category in categories"
                    v-text="category.name"
                ></option>
            </select>
        </label>
        <label for="store">
            or select our A to Z:
            <select id="store" v-model="store" @change="redirectToStore">
                <option value="">All stores</option>
                <option
                    :value="store.url"
                    :key="store.id"
                    v-for="store in stores"
                    v-text="store.name"
                ></option>
            </select>
        </label>
    </form>
</template>
<script>
    export default {
        data() {
            return {
                url: '/api/store/all',
                categories: [],
                stores: [],
                category: '',
                store: '',
            }
        },
        created() {
            axios.post(this.url)
                .then(this.success)
                .catch(this.failure);
        },
        methods: {
            success(response) {
                this.categories = response.data.categories;
                this.stores = response.data.stores;
            },
            failure(error) {
                console.log(error);
            },
            redirectToCategory() {
                if (!this.category) {
                    return;
                }
                window.location.href = this.category;
            },
            redirectToStore() {
                if (!this.store) {
                    return;
                }
                window.location.href = this.store;
            }
        }
    }
</script>